import { TRACKING_SUB_AREA } from '../../../../trackingV2';
import {
  createGetParams,
  createTestCaseSelector,
  createGetPagination,
  createGetNameParam,
  createGetUser,
  createTestCasesTrendsParamsSelector,
} from '../../../common/test-case/selectors';
import * as filtersSelectors from '../../filters/selectors';

export const getTestCase = (store) => store.apps.analytics.rdc.testHistory.testCase;

export const getNameParam = createGetNameParam();
export const getPagination = createGetPagination(getTestCase);
export const getParams = createGetParams({
  getPagination,
  getFiltersParams: filtersSelectors.getFiltersParams,
  getNameParam,
  testCaseStore: getTestCase,
});
export const testCaseSelector = createTestCaseSelector({
  testCaseStore: getTestCase,
  getPagination,
  getTestNameParam: getNameParam,
  source: 'rdc',
  productSubArea: TRACKING_SUB_AREA.TEST_HISTORY,
});
export const testCasesTrendsParamsSelector = createTestCasesTrendsParamsSelector({
  getFiltersParams: filtersSelectors.getFiltersParams,
  getNameParam,
  testCaseStore: getTestCase,
});
export const getUser = createGetUser(getTestCase);
